// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1O2jU","label":"Labeled_label__3zEIF","divider":"Labeled_divider__2oVL3"};